// Module
var code = "<svg viewBox=\"0 0 40 46.922\" width=\"40\" height=\"46.922\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M38.724 25.476c1.71-.955 1.693-2.538 0-3.52L3.087.416C1.412-.556.022.234 0 2.17v42.558c-.022 1.934 1.341 2.744 3.028 1.8l35.696-21.052Z\" fill=\"#FEFEFE\" fill-rule=\"evenodd\" opacity=\".734\"/></svg>";
// Exports
export default code;